// Cómo se reparten los recuadros "generando" dentro de una card del chat —
// ADR-2026-09-09-las-cards-del-chat-generan-como-el-panel.
//
// La card vive en una columna de chat (hasta ~768px), no en la columna de resultados
// de un modo: un solo recuadro a todo el ancho en 9:16 mediría más de una pantalla. Por
// eso el recuadro único se acota, y de dos en adelante van en grilla.
//
// Puro, para testearlo.

/** Ancho máximo del recuadro cuando es uno solo. A 4:5 son ~330px de alto. */
export const ANCHO_MAX_RECUADRO_UNICO_PX = 264;

/**
 * Pacing de la barra para un VIDEO (ms). El de imagen es 80 s; un video tarda "entre 5
 * y 15 minutos" (lo que la card le dice al usuario), así que la barra se pacea a 8: con
 * el easing y el tope de 97 % llega "casi" al final más o menos cuando el video llega
 * (ADR-2026-09-09-video-y-audio-generan-como-el-panel).
 */
export const DURACION_BARRA_VIDEO_MS = 8 * 60_000;

/** Columnas de la grilla según cuántas imágenes se esperan. */
export function columnasParaRecuadros(cantidad: number): 1 | 2 | 3 {
  const n = Math.max(1, Math.floor(cantidad || 1));
  if (n === 1) return 1;
  if (n === 2 || n === 4) return 2;
  return 3;
}

/** Cuántos recuadros dibujar: lo que se espera, con un tope para que la card no se
 *  vuelva una pared (el lote tiene su propia grilla con progreso real). */
export function recuadrosADibujar(cantidad: number, tope = 6): number {
  return Math.min(tope, Math.max(1, Math.floor(cantidad || 1)));
}

// ── Ecualizador del recuadro de audio ──────────────────────────────────────

export interface BarraEcualizador {
  /** Alto en reposo, % del riel. */
  alto: number;
  /** Duración del ciclo (ms). Distinta por barra para que no se muevan en bloque. */
  duracionMs: number;
  /** Desfase inicial (ms, negativo: la animación arranca "ya empezada"). */
  desfaseMs: number;
}

/**
 * Las barras del ecualizador, DETERMINISTAS: la misma cantidad da siempre el mismo
 * dibujo, así el recuadro no "salta" en cada render y el test puede fijarlo. Los
 * multiplicadores son primos para que alto, duración y desfase no se alineen entre
 * barras vecinas y el conjunto se lea orgánico, como una onda de audio.
 */
export function barrasDelEcualizador(cantidad: number): BarraEcualizador[] {
  const n = Math.max(1, Math.floor(cantidad || 1));
  return Array.from({ length: n }, (_, i) => ({
    alto: 30 + ((i * 37) % 61),
    duracionMs: 650 + ((i * 53) % 520),
    desfaseMs: -((i * 97) % 700),
  }));
}
